// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"867b2f2e","703":"7f097939","787":"0dad2ffd"}[chunkId] + ".chunk.js";
};